import React from 'react';
import { at } from 'lodash';
import { useField } from 'formik';
import {
    FormControl,
    Select,
    MenuItem,
    Typography,
    Box,
} from '@mui/material';

const SelectField = (props) => {
    const { errorText, label, name, options, ...rest } = props;
    const [field, meta] = useField(props);
    const { formikProps, activeValidation } = props;

    function _renderHelperText() {
        const [touched, error] = at(meta, 'touched', 'error');
        if (touched && error) {
            return error;
        }
    }

    return (
        <Box sx={{ minWidth: 120 }}>
        <FormControl fullWidth>
            <Typography variant="h5">{label}</Typography>
            <Select {...field} 
            name={name} 
            variant="standard" 
            size="small">
               {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
            </Select>

            <Typography variant="h6" color="error">
                {_renderHelperText()}
            </Typography>
        </FormControl>
        </Box>
    );
};

export default SelectField;
